import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=924f81ca&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=924f81ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924f81ca",
  null
  
)

export default component.exports